import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { cars } from '../data/cars';
import ImageGallery from '../components/ImageGallery';
import MetaTags from '../components/MetaTags';

const Spec = ({ label, value }) => (
  <div>
    <p className="text-sm text-slate-500">{label}</p>
    <p className="font-medium text-slate-700">{value}</p>
  </div>
);

const CheckIcon = () => (
  <svg className="w-5 h-5 text-sky-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const createWhatsAppMessage = (car) => {
    return `Hola, estoy interesado en el ${car.brand} ${car.model} ${car.year}. ¿Podrían darme más información sobre este vehículo?`;
  };

  const CarDetail = () => {
  const { id } = useParams();
  const [currency, setCurrency] = useState('ARS'); // 'ARS' or 'USD'
  const car = cars.find(c => c.id === parseInt(id));

  if (!car) {
    return (
      <div className="py-16 bg-slate-50">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl font-bold text-slate-800 mb-4">Vehículo no encontrado</h1>
          <p className="text-slate-600 mb-8">El vehículo que buscas no existe en nuestro catálogo.</p>
          <Link to="/catalogo" className="bg-sky-600 hover:bg-sky-700 text-white font-bold py-2 px-6 rounded transition-colors">Volver al Catálogo</Link>
        </div>
      </div>
    );
  }

  const specs = [
    { label: 'Marca', value: car.brand },
    { label: 'Modelo', value: car.model },
    { label: 'Año', value: car.year },
    // { label: 'Precio', value: `$${car.price?.toLocaleString('es-AR')}` },
    { label: 'Kilómetros', value: `${car.kilometers.toLocaleString()} km` },
    { label: 'Motor', value: car.engine },
    { label: 'Transmisión', value: car.transmission },
    { label: 'Combustible', value: car.fuel },
    { label: 'ITV', value: car.itv },
    { label: 'Tanque', value: `${car.tanque || 'N/A'} litros` },
    { label: 'Asientos', value: `${car.seats} personas` },
  ];

  return (
    <div className="pt-20 lg:pt-8 bg-slate-50">
      <MetaTags 
        title={`${car.brand} ${car.model} ${car.year} - MRautomotores`}
        description={`Vendé ${car.brand} ${car.model} ${car.year} - ${car.fuel}, ${car.transmission}, ${car.kilometers.toLocaleString()} km. $${car.price?.toLocaleString('es-AR')} - Autos usados en Córdoba con garantía y financiación.`}
        image={car.image}
        url={`https://mrautomotores.com/car/${car.id}`}
        type="product"
      />
      
      <div className="container mx-auto px-4">
        <nav className="mb-8">
          <ol className="flex items-center space-x-2 text-sm text-slate-600">
            <li><Link to="/" className="hover:text-sky-600">Inicio</Link></li>
            <li>/</li>
            <li><Link to="/catalogo" className="hover:text-sky-600">Catálogo</Link></li>
            <li>/</li>
            <li className="text-slate-800 font-medium">{car.brand} {car.model}</li>
          </ol>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-2">
          <div>
            <ImageGallery images={car.gallery || [car.image]} car={car} />
          </div>

          <div>
            <h1 className="text-2xl lg:text-3xl font-bold text-slate-800 mb-4">{car.brand} {car.model}</h1>
            
            {/* Availability Badge */}
            <div className="mb-4">
              <span className={`${car.sold ? 'bg-red-500' : 'bg-green-500'} text-white text-sm font-bold px-3 py-2 rounded-lg inline-block`}>
                {car.sold ? 'VENDIDO' : 'DISPONIBLE'}
              </span>
            </div>
            
            {/* Price Section - Prominent and Aligned */}
            {!car.sold && (
              <div className="bg-gradient-to-r from-sky-50 to-sky-100 rounded-xl p-6 mb-8 border border-sky-200 shadow-sm">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 lg:gap-0">
                  <div className="lg:flex-1">
                    <p className="text-sm text-slate-600 font-medium mb-2 max-[319px]:text-xs max-[319px]:mb-1">Precio</p>
                    <div className="flex flex-col lg:flex-row lg:items-center gap-3">
                        <div className="flex bg-white rounded-lg p-1 border border-slate-300 max-[319px]:p-0.5">
                      <p className="text-2xl lg:text-3xl font-bold text-slate-600 max-[319px]:text-lg max-[319px]:leading-tight">
                        {currency === 'ARS' 
                          ? `$${car.price?.toLocaleString('es-AR')}`
                          : `$${car.priceUSD?.toLocaleString('en-US')}`
                        }
                      </p>
                        <button
                          onClick={() => setCurrency('ARS')}
                          className={`px-2 ml-6 md:ml-24 py-1 rounded-md text-sm font-medium transition-colors max-[319px]:px-1 max-[319px]:ml-3 max-[319px]:py-0.5 max-[319px]:text-xs ${
                            currency === 'ARS' 
                              ? 'bg-sky-500 text-white' 
                              : 'text-slate-600 hover:text-slate-800'
                          }`}
                        >
                          ARS
                        </button>
                        <button
                          onClick={() => setCurrency('USD')}
                          className={`px-3 py-1 rounded-md text-sm font-medium transition-colors max-[319px]:px-2 max-[319px]:py-0.5 max-[319px]:text-xs ${
                            currency === 'USD' 
                              ? 'bg-sky-500 text-white' 
                              : 'text-slate-600 hover:text-slate-800'
                          }`}
                        >
                          USD
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="bg-white rounded-lg p-6 mb-8 border border-slate-200 shadow-sm">
              <h3 className="text-xl font-semibold mb-4 text-slate-800">Especificaciones</h3>
              <div className="grid grid-cols-2 gap-4">
                {specs.map(s => <Spec key={s.label} {...s} />)}
              </div>
            </div>

            <div className="mb-8 pb-8">
              <h3 className="text-xl font-semibold mb-4 text-slate-800">Características</h3>
              <div className="grid grid-cols-2 gap-3">
                {car.features.map((feature, i) => (
                  <div key={i} className="flex items-center space-x-2">
                    <CheckIcon />
                    <span className="text-slate-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            {!car.sold && (
              <div className="sticky bottom-0 bg-slate-50 p-4 -mx-4 border-t border-slate-200">
                <a
                  href={`https://wa.me/5493512161967?text=${encodeURIComponent(createWhatsAppMessage(car))}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition-colors flex items-center justify-center gap-2 shadow-md w-full max-[295px]:py-2 max-[295px]:px-4 max-[295px]:text-sm"
                >
                  <WhatsAppIcon />
                  <span className="max-[295px]:text-xs">Consultar disponibilidad</span>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarDetail;
